import { render, staticRenderFns } from "./PhaseRentab.vue?vue&type=template&id=438f8e53&scoped=true"
import script from "./PhaseRentab.vue?vue&type=script&lang=js"
export * from "./PhaseRentab.vue?vue&type=script&lang=js"
import style0 from "./PhaseRentab.vue?vue&type=style&index=0&id=438f8e53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438f8e53",
  null
  
)

export default component.exports